module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/down_arrow-bd6414f2c7800cdbbbb361109df743a3.png";